import React from 'react'
import {
  IssueContainer,
  InnerIssueContainer,
  MainContent,
  IssueTitle,
  SidebarP,
  Sidebar,
  SidebarHeader,
  SidebarSubheader,
  CloseButton
} from '.'

interface Props {
  handleClose: () => void
}

export default function CriminalJusticeCard({ handleClose }: Props) {
  return (
    <IssueContainer>
      <InnerIssueContainer>
        <MainContent>
          <IssueTitle>End Mass Incarceration</IssueTitle>
          <SidebarP>
            America has the highest rate of incarceration in the world and a structurally racist legal system that disproportionately
            polices, sentences, and incarcerates black and brown communities. Nowhere feels this more than North Nashville, a historically
            black and majority black neighborhood. In 2018, the Brookings Institute listed 37208 as the most incarcerated zip code in the
            United States. The Corrections Corporation of America—founded in Nashville and recently rebranded as CoreCivic—built the
            nation’s private prison industry and still operates over 100 prisons and immigrant detention facilities across the nation. In
            2018, CoreCivic reported $1.83 billion in revenue.
          </SidebarP>
          <SidebarP>
            Justin supports alternatives to incarceration like diversion programs and reformed parole and probation processes. He supports
            ending federal contracts with private prison corporations, including CoreCivic, and demilitarizing the police. He stands against
            inhumane policies like cash bail and mandatory minimums. The state cannot continue to take life in the name of the people and
            Justin supports ending the death penalty at all levels.
          </SidebarP>

          <SidebarP>
            Mass incarceration and the “war on drugs” have torn apart families and communities for decades. To rebuild them, Justin will
            advocate for a comprehensive, sustained effort to strengthen communities affected most. This includes addressing the racial
            wealth gap, income inequality, barriers to higher education, affordable and high quality healthcare (including mental health),
            and access to housing and transportation.
          </SidebarP>
        </MainContent>
        <Sidebar>
          {/* <SidebarHeader>JUSTIN SUPPORTS</SidebarHeader>
          <SidebarSubheader href="https://pressley.house.gov/sites/pressley.house.gov/files/Pressley_The%20People%27s%20Justice%20Guarantee%20FINAL.pdf">
            H.Res. 702 - People’s Justice Guarantee Act
          </SidebarSubheader>
          <SidebarP>Recently introduced by Representative Ayanna Pressley (MA-07).</SidebarP>
          <SidebarSubheader href="https://www.congress.gov/bill/115th-congress/house-bill/3227">
            HR 3227 - Justice is Not For Sale Act (2017).
          </SidebarSubheader>
          <SidebarP>52 Co-Sponsors</SidebarP>
          <SidebarSubheader href="https://www.congress.gov/bill/115th-congress/house-bill/1437">
            HR 1437 - No Money Bail Act (2017).
          </SidebarSubheader>
          <SidebarP>38 Co-Sponsors, including Rep. Steve Cohen (TN-09)</SidebarP> */}
          <SidebarHeader>RESOURCES</SidebarHeader>
          <SidebarSubheader href="https://www.brookings.edu/wp-content/uploads/2018/03/es_20180314_looneyincarceration_final.pdf">
            37208 - Most Incarcerated Zip Code in the Nation
          </SidebarSubheader>
          <SidebarSubheader href="https://www.prisonpolicy.org/reports/incomejails.html">
            How Money Bail Perpetuates an Endless Cycle of Poverty and Jail Time
          </SidebarSubheader>
          <SidebarSubheader href="https://eji.org/news/united-states-still-has-highest-incarceration-rate-world">
            US Still Has Highest Incarceration Rate in the World
          </SidebarSubheader>
          <SidebarSubheader href="https://www.aclu.org/gallery/marijuana-arrests-numbers">
            Marijuana Arrests By the Numbers
          </SidebarSubheader>
          <SidebarSubheader href="https://www.prisonpolicy.org/reports/pie2019.html">
            Mass Incarceration: The Whole Pie 2019
          </SidebarSubheader>
          <SidebarSubheader href="https://www.aclu.org/issues/smart-justice/mass-incarceration/mass-incarceration-animated-series">
            Stories from our Unjust Criminal System
          </SidebarSubheader>
        </Sidebar>
      </InnerIssueContainer>
      <CloseButton onClick={handleClose}>CLOSE</CloseButton>
    </IssueContainer>
  )
}
